


















































































































import { defineComponent, computed, ref, watch, provide } from "@vue/composition-api";
import { Route } from "vue-router";
import * as AssetAPI from "@/services/api/assets";
import { AssetVersion } from "@/psychlab/types";
import { useAssets } from "@/hooks/useAssets";
import { PreviewAssetData } from "@/components.assets/preview-asset-data";
import { ContextOption } from "@/components.generic/context-menu";
import * as AppModal from "@/AppModal";
import { AssetContext } from "./AssetContext";
import { default as UpdateButton } from "./update-button.vue";
import { useTranslate } from "@lang";
import { AbsBox, Date as DateLabel, Icon } from "@ui";
import { ContextHeader } from "@/components.nav/context-header";
import { default as AssetContextArea } from "./asset-context-area.vue";


export default defineComponent({
	components:{
		PreviewAssetData,
		UpdateButton,
		DateLabel,
		Icon,
		ContextHeader,
		AssetContextArea,
		AbsBox,
	},
	beforeRouteEnter(_, from, next){
		next(vm => {
			const setPrevRoute = (vm as any).setPrevRoute;
			if(setPrevRoute){ setPrevRoute(from); }
		});
	},
	setup(_, context){

		const { assets } = useAssets();

		const latestVersion = ref<AssetVersion<any>>();
		const assetId = computed(() => context.root.$route.params["assetId"]);

		const asset = computed(() => {
			return assets.value.find(a => a._id === assetId.value);
		});

		const { translate } = useTranslate();

		const prevRoute = ref<Route>();

		const backTag = ref<string>();

		const isEditing = computed(() => {
			return context.root.$route.name === "asset.edit";
		});

		const isHistory = computed(() => {
			return context.root.$route.name === "asset-history";
		});

		const isViewing = computed(() => {
			return context.root.$route.name === "view-asset";
		});

		const backRoute = computed(() => {
	
			const hasPrevRoute = prevRoute.value && prevRoute.value.name;
			
			if(hasPrevRoute && prevRoute.value?.name === "view-tag"){
				return {
					name:"view-tag",
					params:{
						tagId:prevRoute.value.params["tagId"]
					}
				}
			}

			if(hasPrevRoute && prevRoute.value?.name === "assets"){
				return {
					name:"assets",
					query:{
						t:prevRoute.value.query["t"],
					}
				}
			}

			if(context.root.$route.query["t"]){
				
				return {
					name:"assets",
					query:{
						t:context.root.$route.query["t"],
					}
				}
			}

			return null;

		});

		const viewRoute = computed(() => {
			return {
				name:"view-asset",
				params:{
					assetId:assetId.value
				}
			}
		});

		const editRoute = computed(() => {
			return {
				name:"asset.edit",
				params:{
					assetId:assetId.value
				}
			}
		});

		const historyRoute = computed(() => {
			return {
				name:"asset-history",
				params:{
					assetId:assetId.value
				}
			}
		});

		const showUpdate = computed(() => {
			if(asset.value?.type !== "Graph"){ return false; }
			return true;
		});


		const openRoute = (r:any) => {
			context.root.$router.push(r).catch(() => {})
		};

		const updateRefs = () => {};

		const rename = () => {
			const a = asset.value;
			if(!a){ return; }

			AppModal.editText({
				title:translate("action.rename"),
				value:a.name,
				validator(v){
					return v !== a.name && v.length > 1;
				}
			}, async (v) => {
				try {
					await AssetAPI.setAssetName(a._id, v);
					a.name = v;
				}
				catch(err){
					console.log(err.message);
				}
			})
			
		};

		const setPrevRoute = (r:Route) => {
			prevRoute.value = r;
		}

		const onUpdated = () => {
			init();
		};
		const openContext = (e:Event) => {

			const options:ContextOption[] = [
				{
					name:translate("action.rename"),
					icon:"mdi.pencil",
					fn:rename,
				},
			];

			if(!isViewing.value){
				options.push({
					name:translate("overview"),
					icon:"mdi.information-outline",
					fn(){
						openRoute(viewRoute.value);
					},
					order:1,
				});
			}

			if(!isEditing.value){
				options.push({
					name:translate("action.edit"),
					icon:"mdi.pencil-box",
					fn(){
						openRoute(editRoute.value);
					},
					order:2,
				});
			}

			if(!isHistory.value){
				options.push({
					name:translate("action.viewHistory"),
					icon:"mdi.history",
					fn(){
						openRoute(historyRoute.value);
					},
					order:3,
				});
			}


			AppModal.context(e, options);
		};
		

		const init = async() =>{
			latestVersion.value = await AssetAPI.getAssetVersion(assetId.value, "latest", "+data +vIndex");
			refreshPageTitle();
		};
		

		const refreshPageTitle = () => {
			if(!asset.value){ return; }
			document.title = `${asset.value.name}`;
		};


		const getRouteTag = () => {
			return context.root.$route.query["t"] as string|undefined;
		};

		init();

		watch(asset, () => {
			refreshPageTitle();
		});

		backTag.value = getRouteTag();


		provide<AssetContext>("assetContext", {
			asset,
			assetId,
			backTag:getRouteTag()
		});


		return {
			asset,
			latestVersion,
			editRoute,
			historyRoute,
			viewRoute,
			isEditing,
			isHistory,
			isViewing,
			openContext,
			updateRefs,
			showUpdate,
			onUpdated,
			translate,
			backRoute,
			prevRoute,
			setPrevRoute,
			
		};
	}
});

